// GAStreaming runtime mode helpers.
//
// Android Google Play wrapper token:
// GAStreamingPlayAndroid
//
// iOS App Store wrapper token:
// GAStreamingPlayIOS
//
// The normal website does not use either token.

const PLAY_STORE_ANDROID_UA = "GAStreamingPlayAndroid";
const APP_STORE_IOS_UA = "GAStreamingPlayIOS";

function userAgentIncludes(token) {
  if (typeof navigator === "undefined") return false;

  return String(navigator.userAgent || "").includes(token);
}

export function isAndroidPlayStoreApp() {
  return userAgentIncludes(PLAY_STORE_ANDROID_UA);
}

export function isIOSAppStoreApp() {
  return userAgentIncludes(APP_STORE_IOS_UA);
}

// Keep this original function name for compatibility with the code already
// using it. It now returns true for either official store wrapper.
export function isPlayStoreApp() {
  return isAndroidPlayStoreApp() || isIOSAppStoreApp();
}

export function isNativeStoreApp() {
  return isPlayStoreApp();
}

function normalizeExternalUrl(value) {
  try {
    const parsed = new URL(
      String(value || ""),
      typeof window !== "undefined"
        ? window.location.origin
        : "https://www.gastreaming.live"
    );

    if (!/^https?:$/i.test(parsed.protocol)) return "";

    return parsed.toString();
  } catch {
    return "";
  }
}

export async function openExternalUrl(value) {
  const url = normalizeExternalUrl(value);

  if (!url) {
    throw new Error("A valid secure web address was not returned.");
  }

  if (isNativeStoreApp() && typeof window !== "undefined") {
    const nativeExternalBrowser =
      window?.Capacitor?.Plugins?.ExternalBrowser;

    if (nativeExternalBrowser?.open) {
      await nativeExternalBrowser.open({ url });
      return true;
    }

    const opened = window.open(
      url,
      "_blank",
      "noopener,noreferrer"
    );

    if (opened) return true;
  }

  if (typeof window !== "undefined") {
    window.location.href = url;
    return true;
  }

  return false;
}

export {
  PLAY_STORE_ANDROID_UA,
  APP_STORE_IOS_UA,
};